import React from 'react';
import { Flex, Box } from '@chakra-ui/react';
import { GlobalFooter } from '@/components/global-footer/global-footer';
import { AppHeader } from '@/components/app-header';

export interface AppLayoutProps {
  children: React.ReactNode;
}

export const AppLayout: React.FC<AppLayoutProps> = ({ children }) => {
  return (
    <Flex direction="column" minH="100vh">
      <a
        href="#main-content"
        style={{
          position: 'absolute',
          top: '-40px',
          left: 0,
          background: 'var(--chakra-colors-blue-700)',
          color: 'white',
          padding: '8px 16px',
          zIndex: 100,
          fontWeight: 600,
          textDecoration: 'none',
          borderRadius: '0 0 4px 0',
          transition: 'top 0.1s',
        }}
        onFocus={(e) => { e.currentTarget.style.top = '0'; }}
        onBlur={(e) => { e.currentTarget.style.top = '-40px'; }}
        onClick={(e) => {
          e.preventDefault();
          function findInShadow(root: Document | ShadowRoot, selector: string): HTMLElement | null {
            const el = root.querySelector(selector) as HTMLElement | null;
            if (el) return el;
            for (const child of Array.from(root.querySelectorAll('*'))) {
              if (child.shadowRoot) {
                const found = findInShadow(child.shadowRoot, selector);
                if (found) return found;
              }
            }
            return null;
          }
          const target =
            findInShadow(document, '[aria-label="Chat message input"]') ||
            findInShadow(document, '#main-content');
          target?.focus();
        }}
      >
        Skip to main content
      </a>
      <AppHeader />
      <Box as="main" flex="1" id="main-content" tabIndex={-1}>
        {children}
      </Box>
      <GlobalFooter />
    </Flex>
  );
};

export default AppLayout;
